import { Stack, Typography } from '@mui/material'

import Feedback from '../organisms/Feedback'

export const Footer = () => (
  <Stack
    bgcolor="background.paper"
    boxSizing="border-box"
    component="footer"
    height={48}
    sx={{
      justifyContent: 'center',
      gap: { xs: 2, md: 20 },
      borderTop: 'solid 1px',
      borderTopColor: 'divider',
      zIndex: theme => theme.zIndex.appBar,
      position: 'relative',
      fontSize: { xs: 10, sm: 'initial' },
    }}
  >
    <Stack
      alignItems="center"
      boxSizing="border-box"
      direction="row"
      sx={{
        width: 'calc(100vw - 32px)',
        display: 'flex',
        justifyContent: 'space-between',
        position: 'sticky',
        left: 0,
        px: { xs: 2, md: 4 },
      }}
    >
      <Typography
        color="text.secondary"
        sx={{ lineHeight: '110%' }}
        variant="subtitle1"
      >
        ООО «Интэнт». Санкт-Петербург
      </Typography>
      <Stack direction="row" gap={2}>
        {/*<Link*/}
        {/*  color="text.primary"*/}
        {/*  href="https://builddocs.atlassian.net/l/c/Rw5hR1Cg"*/}
        {/*  sx={{ cursor: 'pointer' }}*/}
        {/*  underline="hover"*/}
        {/*>*/}
        {/*  Что нового?*/}
        {/*</Link>*/}
        <Feedback />
        {/*<Link*/}
        {/*  color="text.primary"*/}
        {/*  href="https://builddocs.atlassian.net/servicedesk/customer/portals"*/}
        {/*  sx={{ cursor: 'pointer' }}*/}
        {/*  underline="hover"*/}
        {/*>*/}
        {/*  Справка*/}
        {/*</Link>*/}
      </Stack>
    </Stack>
  </Stack>
)

export default Footer
